import { render, staticRenderFns } from "./TenantGateway.vue?vue&type=template&id=482abccb&"
import script from "./TenantGateway.vue?vue&type=script&lang=ts&"
export * from "./TenantGateway.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports